import { render, staticRenderFns } from "./RedPackageUser.vue?vue&type=template&id=1d068bf0&scoped=true&"
import script from "./RedPackageUser.vue?vue&type=script&lang=js&"
export * from "./RedPackageUser.vue?vue&type=script&lang=js&"
import style0 from "./RedPackageUser.vue?vue&type=style&index=0&id=1d068bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d068bf0",
  null
  
)

export default component.exports